var regPhoneController = {
    regModalPhone: $('#regModalPhone'),
    regModalCode: $('#regModalPhoneCode'),
    regModalFailed: $('#regModalPhoneFailed'),
    elForm: $('#regPhone'),
    itiRegPhone: null,
    phone: '',
    countryCode: '',
    init: function(itiRegPhone)
    {
        regPhoneController.itiRegPhone = itiRegPhone;
        regPhoneController.elForm.find('.error-text').hide();

        regPhoneController.elForm.find('button').click(function() {
            regPhoneController.submitForm();

            return false;
        });

        regPhoneController.regModalCode.find('.js-send-again').click(function() {
            regPhoneController.submitForm();

            return false;
        });

        regPhoneController.regModalFailed.find('.js-return').click(function () {
            regPhoneController.regModalPhone.modal('show');
            regPhoneController.regModalFailed.modal('hide');
        });
    },
    submitForm: function()
    {
        regPhoneController.phone = regPhoneController.itiRegPhone.getNumber();
        regPhoneController.phone = regPhoneController.phone.replace(/\D/g, "");
        regPhoneController.countryCode = regPhoneController.itiRegPhone.getSelectedCountryData().iso2.toUpperCase();

        if (!regPhoneController.validateForm()) {
            regPhoneController.showError();

            return false;
        }

        regPhoneController.elForm.find('.js-input-phone-number').val(regPhoneController.phone);
        regPhoneController.elForm.find('.js-input-phone-country-code').val(regPhoneController.countryCode);

        $.post(
            regPhoneController.elForm.attr('action'),
            regPhoneController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    regPhoneController.regModalCode.modal('show');
                    regPhoneController.regModalCode.find('.tip-text span').text(regPhoneController.phone);
                    regPhoneController.regModalCode.find('.js-input-phone-number').val(regPhoneController.phone);
                    regPhoneController.regModalCode.find('.js-input-phone-country-code').val(regPhoneController.countryCode);
                    regPhoneController.regModalPhone.modal('hide');
                    authBaseController.startCountdown(
                        regPhoneController.regModalCode.find('.js-countdown'),
                        regPhoneController.regModalCode.find('.js-send-again')
                    );
                } else {
                    if(data.isUserExists) {
                        regPhoneController.regModalFailed.find('.text-top').text(data.message);
                        regPhoneController.regModalFailed.modal('show');
                        regPhoneController.regModalPhone.modal('hide');
                    } else {
                        regPhoneController.regModalPhone.find('.error-text').text(data.message);
                        regPhoneController.showError();
                    }
                }
            }, 'json');
    },
    validateForm: function()
    {
        regPhoneController.clearForm();
        return regPhoneController.itiRegPhone.isValidNumber();
    },
    clearForm: function()
    {
        regPhoneController.elForm.find('.form-group').removeClass('has-error');
        regPhoneController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        regPhoneController.elForm.find('.form-group').addClass('has-error');
        regPhoneController.elForm.find('.error-text').show();
    }
};

$(document).ready(function(){
    var regPhoneInput = document.getElementById("regPhoneIti");
    var itiRegPhone = window.intlTelInput(regPhoneInput, {
        initialCountry: "auto",
        separateDialCode: true,
        geoIpLookup: function (callback) {
            $.get('https://ipinfo.io', function () {
            }, "jsonp").always(function (resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        utilsScript: "/js/plugins/intl-tel-input-17.0.0/build/js/utils.js" // just for formatting/placeholders etc
    });

    regPhoneController.init(itiRegPhone);
});
